function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@limitless/modern/data-display/typography/Typography";
const useStyles = makeStyles(theme => {
  var _theme$background;
  return {
    box: {
      display: "flex",
      width: ({
        fullBoxWidth
      }) => fullBoxWidth ? "auto" : "fit-content",
      margin: ({
        noMargin
      }) => noMargin ? 0 : 4,
      padding: ({
        noMargin,
        addPadding
      }) => !noMargin || addPadding ? "4px 8px" : 0,
      textAlign: ({
        centerTextAlign
      }) => centerTextAlign ? "center" : "inherit"
    },
    noMargin: {
      margin: 0
    },
    buttonBase: {
      width: "100%",
      position: "relative"
    },
    radius: {
      borderRadius: 8
    },
    row: {
      marginRight: 5
    },
    "default-contained": {
      backgroundColor: (_theme$background = theme.background) === null || _theme$background === void 0 ? void 0 : _theme$background.gray
    },
    "green-outlined": {
      color: "#72BA54",
      border: "2px solid #72BA54"
    },
    "green-contained": {
      color: "#fff",
      backgroundColor: "#72BA54"
    },
    "blue-outlined": {
      color: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main}`
    },
    "blue-contained": {
      color: "#fff",
      backgroundColor: theme.palette.primary.main
    },
    "orange-outlined": {
      color: "#ff9800",
      //orange
      border: "2px solid #ff9800" //orange
    },
    "orange-contained": {
      color: "#fff",
      backgroundColor: "#ff9800" //orange
    },
    "red-outlined": {
      color: theme.palette.error.main,
      border: `2px solid ${theme.palette.error.main}`
    },
    "red-contained": {
      color: "#fff",
      backgroundColor: theme.palette.error.main
    },
    "secondary-main-contained": {
      color: "#fff",
      backgroundColor: theme.palette.secondary.main
    },
    "secondary-light-contained": {
      color: "#fff",
      backgroundColor: theme.palette.secondary.light
    },
    "error-cold-contained": {
      color: "#fff",
      backgroundColor: theme.palette.error.light
    },
    "primary-main-contained": {
      color: "#fff",
      backgroundColor: theme.palette.primary.main
    },
    "red-caption": {
      color: theme.palette.primary.dark,
      backgroundColor: theme.palette.error.light
    },
    "secondary-main-caption": {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.light
    },
    "error-light-caption": {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.error.light
    },
    "error-cold-caption": {
      color: theme.palette.primary.dark,
      backgroundColor: theme.palette.error.light
    },
    "warning-light-caption": {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.warning.light
    }
  };
});
const BoxRenderer = ({
  value,
  color,
  direction = "column",
  onValueChange,
  autoCapitalize = false,
  showRadius,
  variant = "contained",
  fontSize = "12",
  fontWeight = "unset",
  containerStyles = {},
  noMargin = false,
  addPadding = false,
  centerTextAlign = false,
  fullBoxWidth = false,
  children,
  ...rest
}) => {
  const classes = useStyles({
    noMargin,
    addPadding,
    centerTextAlign,
    fullBoxWidth
  });
  const typoStyle = {
    fontSize,
    fontWeight
  };
  typoStyle.textTransform = autoCapitalize ? "capitalize" : "unset";
  const renderChildComponent = () => {
    var _classes;
    if (variant === "caption") {
      rest["variant"] = variant;
    }
    return /*#__PURE__*/React.createElement("div", {
      style: containerStyles,
      className: classes.buttonBase
    }, children && children, /*#__PURE__*/React.createElement(Typography, _extends({
      sx: {
        color: (_classes = classes[`${color}-${variant}`]) === null || _classes === void 0 ? void 0 : _classes.color
      },
      style: typoStyle
    }, rest), value));
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `${classes.box} ${showRadius ? classes.radius : ""} ${classes[`${color}-${variant}`]} ${classes[direction]}`
  }, rest), typeof onValueChange === "function" ? /*#__PURE__*/React.createElement(ButtonBase, {
    onClick: onValueChange,
    className: classes.buttonBase,
    disabled: typeof onValueChange === "function" ? false : true
  }, renderChildComponent()) : renderChildComponent());
};
export default BoxRenderer;
BoxRenderer.propTypes = {
  containerStyles: PropTypes.object,
  color: PropTypes.string.isRequired,
  direction: PropTypes.string,
  value: PropTypes.string.isRequired,
  onValueChange: PropTypes.func,
  autoCapitalize: PropTypes.bool,
  variant: PropTypes.string,
  showRadius: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  noMargin: PropTypes.bool,
  addPadding: PropTypes.bool,
  centerTextAlign: PropTypes.bool,
  fullBoxWidth: PropTypes.bool
};